module.exports = __webpack_public_path__ + "img/192.bb1aa279.jpg";